import { createSvgComponent } from "../../icon/createSvgComponent";
import Logo from "@core/icon/assets/logo.svg";
export default createSvgComponent(Logo);